const MAX_VIDEO_DURATION_IN_MINUTES: number = 45;
const MAX_VIDEO_DURATION_IN_SECONDS: number = 60 * MAX_VIDEO_DURATION_IN_MINUTES;
const MAX_FILE_SIZE_IN_BYTE: number = 104 * 1000 * 1000;

export * from './ProductId';

export { MAX_VIDEO_DURATION_IN_MINUTES, MAX_VIDEO_DURATION_IN_SECONDS, MAX_FILE_SIZE_IN_BYTE };
